module.exports = __webpack_public_path__ + "static/AccountInfo-adb840b2fbf334902e81a17b27d5744c.png";